import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../images/logo.svg";
import ThemeToggle from "./ThemeToggle";
import CartBadge from "./CartBadge";

export default function Heading() {
  const [open, setOpen] = useState(false);

  return (
    <header className="relative h-24 md:h-28 bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-white shadow">
      {/* Floating background logo */}
      <div className="absolute top-0 left-0 z-0 opacity-10 pointer-events-none">
        <Logo className="w-64 h-64" />
      </div>

      {/* Bar */}
      <div className="relative z-10 flex items-center justify-between h-full max-w-7xl mx-auto px-4">
        {/* Mobile menu button */}
        <button
          className="md:hidden inline-flex items-center justify-center p-2 rounded hover:bg-black/5 dark:hover:bg-white/10 focus:outline-none"
          aria-label="Toggle navigation"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="sr-only">Open main menu</span>
          {/* simple hamburger */}
          <div className="space-y-1.5">
            <span className="block h-0.5 w-6 bg-current"></span>
            <span className="block h-0.5 w-6 bg-current"></span>
            <span className="block h-0.5 w-6 bg-current"></span>
          </div>
        </button>

        {/* Desktop nav + toggle */}
        <div className="hidden md:flex items-center gap-4">
          <nav>
            <ul className="flex gap-6 text-sm md:text-base font-medium">
              <li><Link to="/" className="hover:text-blue-600 dark:hover:text-blue-400 transition">HOME</Link></li>
              <li><Link to="/services" className="hover:text-blue-600 dark:hover:text-blue-400 transition">SERVICES</Link></li>
              <li><Link to="/gallery" className="hover:text-blue-600 dark:hover:text-blue-400 transition">GALLERY</Link></li>
              <li><Link to="/store" className="hover:text-blue-600 dark:hover:text-blue-400 transition">STORE</Link></li>
              <li><Link to="/contact" className="hover:text-blue-600 dark:hover:text-blue-400 transition">CONTACT</Link></li>
            </ul>
          </nav>
          <CartBadge />
          <ThemeToggle />
        </div>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:hidden relative z-10 border-t border-black/10 dark:border-white/10 bg-white/80 dark:bg-gray-900/80 backdrop-blur">
          <nav className="max-w-7xl mx-auto px-4 py-4">
            <ul className="flex flex-col gap-3 text-base font-medium">
              <li><Link onClick={() => setOpen(false)} to="/" className="block py-1 hover:text-blue-600 dark:hover:text-blue-400">HOME</Link></li>
              <li><Link onClick={() => setOpen(false)} to="/services" className="block py-1 hover:text-blue-600 dark:hover:text-blue-400">SERVICES</Link></li>
              <li><Link onClick={() => setOpen(false)} to="/gallery" className="block py-1 hover:text-blue-600 dark:hover:text-blue-400">GALLERY</Link></li>
              <li><Link onClick={() => setOpen(false)} to="/store" className="block py-1 hover:text-blue-600 dark:hover:text-blue-400">STORE</Link></li>
              <li><Link onClick={() => setOpen(false)} to="/contact" className="block py-1 hover:text-blue-600 dark:hover:text-blue-400">CONTACT</Link></li>
              <li className="pt-2 border-t border-black/10 dark:border-white/10">
                <CartBadge onClick={() => setOpen(false)} />
              </li>
            </ul>
            <div className="mt-4"><ThemeToggle /></div>
          </nav>
        </div>
      )}
    </header>
  );
}
